<template>
  <div class="page contact">
    <div class="me">
      <img class="me__pic" src="/static/logo_wide.jpg"></img>
      <div class="me__description">
        <p>
          Bendpanic Production is a creative studio specialised in stop-motion and 2D animation run by director and visual artist Veronica Solomon. We work on bring ideas to life in charming and inspiring narratives connecting with the audience through meaning, emotions and original content with a focus on character driven storytelling.
Based in Tampere - Finland, active worldwide.

        </p>
        <p>
          Our creative process draws on over 20 years of experience in artistic creation and animation production. We support our in-house animation services with a network of trusted and highly capable collaborators. Our portfolio includes a selection of original productions and commissioned works that best reflects our variety of style and techniques.
        </p>

        <div class="lists">
          <div class="clients">
            <h3>Clients</h3>
            <ul>
              <li v-for="client in clients">
                {{ client }}
              </li>
            </ul>
          </div>

          <div class="social">
            <h3>Contact</h3>
            <ul>
              <li v-for="contact in contacts">
                <a :href="contact.href" target="_blank">
                  {{ contact.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'contact',
  components: {
  },
  data () {
    const email = this.$store.getters.email;

    return {
      contacts: [
        {
          name: 'e-mail',
          href: `mailto:${email}`
        },
        {
          name: 'linkedin',
          href: 'https://www.linkedin.com/company/bendpanic-production'
        },
        {
          name: 'instagram',
          href: 'https://www.instagram.com/bendpanic/'
        },
        {
          name: 'facebook',
          href: 'https://www.facebook.com/bendpanic'
        }
      ],
      clients: [
        'Green Peace',
        'Wolkenlenker',
        'Nexus Studios',
        'Cake FX',
        'NRDC',
        'Arte Deutschland',
        'MobyDok',
        'DCMN',
        'Climate Media Factory',
        'FAB Berlin',
        'IraRu Films',
        'Clay Traces',
        'Talking Animals',
        'Arte',
        'DeFilm',
        'Castel Film'
      ]
    }
  }
}
</script>

<style lang="scss">

.contact {
  ul {
    li {
      padding-bottom: 0.5rem;
    }
  }

  .me {
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 512px) {
      &__pic {
      }

      &__description {
        padding: 0 0.8rem;
      }
    }

    &__description {
      flex: 1;
      padding-top: 1rem;
    }

    &__pic {
    }
  }
}

.lists {
  display: flex;
}

.clients {
  padding-top: 1rem;
  flex: 1;
}

.social {
  padding-top: 1rem;
  flex: 1;
}

.clients > ul > li {
  font-size: 0.8rem;
  font-family: 'Helvetica Neue', Fallback, sans-serif;
  padding-bottom: 0.5rem;
}

.contact > .social > a {
  font-size: 2rem;
}

.icon-mail {
  font-size: 1.8rem;
}

.icon-vimeo {
  font-size: 1.8rem;
}

.icon-blogger {
  font-size: 1.6rem;
}
</style>




// WEBPACK FOOTER //
// About.vue?24411ad7